import { convertLabelMapToConfig, mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';

const getLabelConfig = (prefix: string) =>
  mergeConfig(
    convertLabelMapToConfig({
      [`${prefix}.Preparation.AddSieveSizesBasedOnSpecification`]: 'Sieves Are Added',
    })
  );

export default getLabelConfig;
